import styled from 'styled-components';

const ArrowImg = styled.img`
  width: 0.8em;
  height: auto;
  padding-left: 0.25em;
`;

const ImageWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  height: 229px;
  width: 172px;
`;

const RelatedProductsWrapper = styled.div`
  margin: 10% 5% 5% 5%;
`;

const SliderCell = styled.div`
  & {
    * {
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  width: 172px;
  box-sizing: border-box;
  display: inline-block;
  overflow: hidden;
  padding: 0.1em;
  text-align: center;
  user-select: none;
  vertical-align: top;
`;

const SliderRow = styled.div`
  overflow-x: scroll;
  overflow-y: hidden;
  user-select: none;
  white-space: nowrap;
  width: 100%;
`;

const Subtext = styled.div`
  color: #999;
  margin-bottom: 1em;
  text-align: right;
  user-select: none;
`;

const Title = styled.div`
  color: #000;
  font-family: "Avenir Black", "Arial Black", sans-serif;
  font-size: 15px;
  letter-spacing: 1px;
  margin: 0 1em;
  text-transform: uppercase;
`;

const ViewMore = styled.div`
  white-space: normal;
  font-size: 15px;
  margin: 0 10px;
  
  & span {
    font-family: "Avenir Black", "Arial Black", sans-serif;
    font-size: 15px;
  }
`;

export { ArrowImg, ImageWrapper, RelatedProductsWrapper, SliderCell, SliderRow, Subtext, Title, ViewMore };
